import Model, { attr } from '@warp-drive/legacy/model';
import type { Type } from '@warp-drive/core/types/symbols';
import type { FragmentArray } from 'ember-data-model-fragments/array/fragment';
import { fragment, fragmentArray } from 'ember-data-model-fragments/attributes';
import type Section from '@linc-technologies/linced-common/models/enrolments/section';

// Proto: enrolments.TemplateSchema.
export default class Schema extends Model {
  declare [Type]: 'enrolments/schema';

  // Model Attributes
  // createTime is when the resource was created in seconds from the epoch.
  @attr('number')
  declare createTime: number | undefined;

  // updateTime is the last time the resource was modified in seconds from
  // the epoch.
  @attr('number')
  declare updateTime: number | undefined;

  // templateName is the name of the template.
  @attr('string', { defaultValue: '' })
  declare templateName: string;

  // enrolmentYear is the year for which the enrolment intake is for.
  @attr('number', { defaultValue: 0 })
  declare enrolmentYear: number;

  // enrolmentsOpen provides a switch for schools that prefer to be reactive.
  @attr('boolean', { defaultValue: false })
  declare enrolmentsOpen: boolean;

  // dateEnrolmentsOpen contains a 'yyyy-mm-dd' date string as to when
  // enrolments will open.
  @attr('date')
  declare dateEnrolmentsOpens: Date | undefined;

  // dateEnrolmentsClose contains a 'yyyy-mm-dd' date string as to when
  // enrolments will close.
  @attr('date')
  declare dateEnrolmentsClose: Date | undefined;

  // introduction provides an overall welcome to the school's enrolment page.
  @attr('string', { defaultValue: '' })
  declare introduction: string;

  // sections contain a conceptual whole of data needed to enrol a student.
  @fragmentArray('enrolments/section')
  declare sections: FragmentArray<Section>;

  // primaryContacts contains schema metadata relating to primary contacts.
  @fragment('enrolments/section')
  declare primaryContacts: Section | null;

  // emergencyContacts contains schema metadata relating to secondary contacts.
  @fragment('enrolments/section')
  declare emergencyContacts: Section | null;

  // medicalContacts contains schema metadata relating to secondary contacts.
  @fragment('enrolments/section')
  declare medicalContacts: Section | null;

  // medicalConditions contains schema metadata relating to medical conditions.
  @fragment('enrolments/section')
  declare medicalConditions: Section | null;
}
